module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAlElEQVRYhe3T0Q2AIAwE0MO5WIINdAESV2EBGcEhGMRNMCZ+CViBYDD2Po29Poji9xElF+C1XACMl8dWGDfldmUDEsuLEQGAWFCbADhEClstj3bHAK8mBrANAS27PxryN/Ra+pqjCeNud3T5ETKAAQxgAAMYwIDuAFtFPzn7BDBXAMhZEiCMWwGozJs43lXnLCcdADtxAB5DCk4C/QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/ic_btn_delete@2x.png
// module id = 731
// module chunks = 0